export default __webpack_public_path__ + "media/images/en-gb-22d84fe88ebe4c35e1ac0b36dfd935a3.svg";